module.exports = __webpack_public_path__ + "static/hero-42fcc4ffa751440c65a48b13f4239d88.jpg";